import * as yup from 'yup';
import { Validations } from '../../config';

export const getInputSchema = (text) => {
  const schemaEntries = text.reduce((acc, item) => {
    acc[item.value] = Validations.customText;
    return acc;
  });

  return yup.object().shape(schemaEntries);
};

export const generateValidationSchema = (fields) => {
  const schemaFields = {};
  const maxLengthMap = {};

  const panFields = new Set(['entity', 'pancard', 'pan', 'pan_number', 'panNumber']);
  const ifscFields = new Set(['ifsc_number', 'ifsc_code', 'ifsc', 'ifscNumber']);
  const sourcePincodeFields = new Set(['pincode1', 'sourcePinCode']);
  const destinationPincodeFields = new Set(['pincode2', 'distPinCode']);
  const dlFields = new Set(['dl_number', 'dlNumber']);
  const aadhaarFields = new Set(['aadhaar_number', 'aadhaar', 'aadhaarNumber']);
  const gstFields = new Set(['gst_number', 'gstNumber', 'gstnumber', 'gstin']);
  const vehicleFields = new Set(['vehicleNumber', 'vehicle_number']);
  const stringFields = new Set(['str1', 'str2', 'query', 'reference']);
  const epicFields = new Set(['epic_number', 'epicNumber']);

  fields.forEach((field) => {
    if (panFields.has(field.value)) {
      schemaFields[field.value] = yup.string().required('PAN Number is required').matches(/^[A-Za-z0-9]{10}$/, 'PAN Number must be 10 alphanumeric digits');
      maxLengthMap[field.value] = 10;
      return;
    }

    if (field.value === 'din_number') {
      schemaFields[field.value] = yup.string().required('DIN Number is required').matches(/^[A-Za-z0-9]{10}$/, 'DIN Number must be 20 alphanumeric digits');
      maxLengthMap[field.value] = 20;
      return;
    }

    if (field.value === 'acc_number') {
      schemaFields[field.value] = yup.string().required('Account number is required').matches(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9]{5,20}$/, 'Invalid bank account number format. Must be 5 to 20 alphanumeric digits.');
      maxLengthMap[field.value] = 20;
      return;
    }

    if (ifscFields.has(field.value)) {
      schemaFields[field.value] = yup.string().required('IFSC code is required').matches(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9]{11}$/, 'Invalid IFSC code format. Must be 11 alphanumeric digits.');
      maxLengthMap[field.value] = 11;
      return;
    }

    if (sourcePincodeFields.has(field.value)) {
      schemaFields[field.value] = yup.string().required('Source Pincode is required').matches(/^\d{6}$/, 'Invalid Source Pincode format. Must be 6 digits.');
      maxLengthMap[field.value] = 6;
      return;
    }

    if (destinationPincodeFields.has(field.value)) {
      schemaFields[field.value] = yup.string().required('Destination Pincode is required').matches(/^\d{6}$/, 'Invalid Destination Pincode format. Must be 6 digits.');
      maxLengthMap[field.value] = 6;
      return;
    }

    if (dlFields.has(field.value)) {
      schemaFields[field.value] = yup.string().required('Driving License Number is required').matches(/^[A-Za-z0-9]{5,20}$/, 'Driving License Number must be 5 to 20 alphanumeric digits');
      maxLengthMap[field.value] = 20;
      return;
    }

    if (aadhaarFields.has(field.value)) {
      schemaFields[field.value] = yup.string().required('Aadhar Number is required').matches(/^\d{12}$/, 'Aadhar Number must be exactly 12 numeric digits');
      maxLengthMap[field.value] = 12;
      return;
    }

    if (gstFields.has(field.value)) {
      schemaFields[field.value] = yup.string().required('GST Number is required').matches(/^[A-Za-z0-9]{15}$/, 'GST Number must be 15 alphanumeric digits');
      maxLengthMap[field.value] = 15;
      return;
    }

    if (field.value === 'mobile_number') {
      schemaFields[field.value] = yup.string().required('Mobile Number is required').matches(/^\d{10}$/, 'Mobile Number must be exactly 10 numeric digits');
      maxLengthMap[field.value] = 10;
      return;
    }

    if (field.value === 'iec_number') {
      schemaFields[field.value] = yup.string().required('ICE Number is required').matches(/^[A-Za-z0-9]{10}$/, 'ICE Number must be 10 alphanumeric digits');
      maxLengthMap[field.value] = 10;
      return;
    }

    if (vehicleFields.has(field.value)) {
      schemaFields[field.value] = yup.string().required('Vehicle Number is required').matches(/^[A-Za-z0-9]{8,12}$/, 'Invalid Vehicle number format. Must be 8 to 12 alphanumeric digits.');
      maxLengthMap[field.value] = 12;
      return;
    }

    if (stringFields.has(field.value)) {
      const requiredMessage = field.value === 'str1' || field.value === 'reference'
        ? 'String1 is required'
        : 'String2 is required';
      schemaFields[field.value] = yup
        .string()
        .required(requiredMessage)
        .matches(/^[A-Za-z ]{1,100}$/, 'Only alphabets allowed. No numbers or special characters.');
      maxLengthMap[field.value] = 100;
      return;
    }

    if (field.value === 'dinNumber') {
      schemaFields[field.value] = yup.string().required('DIN Number is required').matches(/^\d{8}$/, 'DIN Number must be 8 digits');
      maxLengthMap[field.value] = 8;
      return;
    }

    if (epicFields.has(field.value)) {
      schemaFields[field.value] = yup.string().required('Voter ID Epic number is required').matches(/^[A-Za-z0-9]{5,20}$/, field.value === 'epicNumber' ? 'Invalid Voter ID number format. Must be 5 to 20 alphanumeric digits.' : 'Invalid Voter ID Epic number');
      maxLengthMap[field.value] = 20;
      return;
    }

    if (field.value === 'engineNumber') {
      schemaFields[field.value] = yup.string().required('Engine number is required').matches(/^[A-Za-z0-9]{5,20}$/, 'Invalid Engine number format. Must be 5 to 20 alphanumeric digits.');
      maxLengthMap[field.value] = 20;
      return;
    }

    if (field.value === 'chassisNumber') {
      schemaFields[field.value] = yup.string().required('Chassis number is required').matches(/^[A-Za-z0-9]{5,20}$/, 'Invalid Chassis number format. Must be 5 to 20 alphanumeric digits.');
      maxLengthMap[field.value] = 20;
      return;
    }

    if (field.value === 'accNumber') {
      schemaFields[field.value] = yup.string().required('Account number is required').matches(/^[A-Za-z0-9]{5,20}$/, 'Invalid bank account number format. Must be 5 to 20 alphanumeric characters.');
      maxLengthMap[field.value] = 20;
      return;
    }

    if (field.value === 'email') {
      schemaFields[field.value] = yup
        .string()
        .required('Email is required')
        .max(254, 'Email is too long')
        .email('Invalid email format')
        .test('no-consecutive-dots', 'Email cannot contain consecutive dots', (value) => {
          return value ? !/\.{2,}/.test(value) : false;
        })
        .test('domain-dot-check', 'Email domain must contain a dot (e.g. example.com)', (value) => {
          if (!value) return false;
          const domain = value.split('@')[1]?.toLowerCase();
          return !!domain && domain.includes('.');
        })
        .test('valid-characters', 'Invalid characters in email', (value) => {
          return value
            ? /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/.test(value)
            : false;
        })
        .test('gmail-domain-check', 'Gmail must end with .com, .co, or .in', (value) => {
          if (!value) return false;
          const domain = value.split('@')[1]?.toLowerCase();
          if (!domain) return false;

          if (domain.startsWith('gmail.')) {
            return ['com', 'co', 'in'].some((tld) => domain.endsWith(`.${tld}`));
          }
          return true;
        });

      maxLengthMap[field.value] = 254;
      return;
    }

    if (field.value === 'ip') {
      schemaFields[field.value] = yup
        .string()
        .required('IP Address is required')
        .test('ip-format', 'Invalid IPv4 or IPv6 Address format', (value) => {
          if (typeof value !== 'string') return false;

          const trimmedValue = value.trim();
          if (trimmedValue === '') return false;

          const ipv4Pattern = /^(?!0)(?!.*\.$)((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.|$)){4}$/;
          const ipv6Pattern = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|(::)|([0-9a-fA-F]{1,4}::[0-9a-fA-F]{1,4}))$/;

          return ipv4Pattern.test(trimmedValue) || ipv6Pattern.test(trimmedValue);
        });
      maxLengthMap[field.value] = 45;
      return;
    }

    schemaFields[field.value] = yup.string().required(`Please enter ${field.label}`);
  });

  return { schema: yup.object().shape(schemaFields), maxLengthMap };
};
